module.exports = __webpack_public_path__ + "assets/96853600789a57b78d4497e088171a06.mp4";